<template>
    <a :href="GetLink()" :target="GetTarget()">
        <ToolButton :Editor="Editor" KnownIcon="ExternalLink" :Size="10">

        </ToolButton>
    </a>
</template>
<script>

import ToolButton from "@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue";

export default ({
    methods: {
        GetLink() {
            if (this.Editor) {
                var url = this.Editor.getAttributes('link').href;
                return url;
            }
            return '';
        },
        GetTarget(){
            if (this.Editor) {
                var url = this.Editor.getAttributes('link').target;
                return url;
            }
            return '';
        }
    },
    components: {
        ToolButton
    },
    props: ["Editor"]
});
</script>